module.exports = __webpack_public_path__ + "static/media/coast.090b1221.svg";